<template>
<div>
    <div class="mt-2">
        <v-btn text class="grey--text text--darken-1" @click="$router.push('/admin-sessions')">
            <v-icon size="14px" color="grey darken-1" class="mr-3">fa-angle-left</v-icon>
            Back to Sessions
        </v-btn>
    </div>

    <v-row>
        <v-col cols="12" sm="8">
            <v-card outlined>
                <v-card-text :class="($vuetify.breakpoint.xsOnly) ? 'pa-4' : 'px-8 py-4'">
                    <div class="subtitle-1 font-weight-medium primary--text mb-4">Update support materials</div>

                    <!-- TYPE -->
                    <v-select
                        v-model="model.session"
                        :items="sessions"
                        item-text="title"
                        item-value="id"
                        append-icon="fa-angle-down accent--text"
                        outlined dense
                        @change="getSession"
                        label="Select the session">
                    </v-select>

                    <div v-if="loaded && model.session != ''">
                        <!-- MATS -->
                        <div class="ml-8 mb-2 title primary--text font-weight-medium">Materials:</div>
                        <div class="ml-10 mb-1 d-flex align-center" v-for="(mat, index) in model.materials" :key="mat.id">
                            <v-icon small class="mr-1" color="primary">fa-angle-right</v-icon>
                            <div class="grey--text text--darken-4 subtitle-1">{{mat.title}}</div>
                            <v-icon small color="red darken-1" class="ml-3" @click="tryConfirm(index)">fa-trash</v-icon>
                        </div>
                        <div class="ml-8 mt-n2" v-if="model.materials.length == 0">No materials yet.</div>

                        <div class="text-center mt-4 mb-4">
                            <v-btn depressed class="accent" @click="showUpSession=true">
                                <v-icon left small color="white">fa-cloud-upload-alt</v-icon>
                                <span>Upload file</span>
                            </v-btn>
                        </div>

                        <v-divider class="mb-4 mt-6"></v-divider>

                        <!-- BULLETS -->
                        <div class="ml-8 mb-2 title primary--text font-weight-medium">Tips:</div>
                        <div v-for="(item, index) in model.tips" :key="item.id">
                            <div class="d-flex align-center">
                                <v-text-field
                                    class="pr-2"
                                    v-model="model.tips[index]"
                                    :label="(index+1) + '.'"
                                    maxlength="1000"
                                    outlined dense>
                                    <template v-slot:prepend>
                                        <v-icon color="info" class="mt-1 mr-1" small>fa-chevron-right fa-fw</v-icon>
                                    </template>
                                </v-text-field>
                            </div>
                            <div class="pl-8 pr-2">
                                <v-btn 
                                    v-if="index == model.tips.length-1"
                                    :disabled="model.tips[index] == ''"
                                    depressed block
                                    class="mt-n4" 
                                    color="primary"
                                    @click="model.tips.push('')">
                                    <v-icon small color="white" left>fa-plus</v-icon> One more tip
                                </v-btn>
                            </div>
                        </div>

                        <!-- BUTTON -->
                        <div class="text-center mt-8 mb-4">
                            <v-btn 
                                depressed 
                                class="accent" 
                                @click="validate" 
                                :disabled="sending">Update session {{model.session.substr(1, model.session.length)}}</v-btn>
                        </div>
                    </div>

                    <SendingLoader v-if="!loaded"/>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <DiagSessions
        v-if="model.session != '' && loaded"
        :model="showUpSession"
        :session="model.session"
        :materials="model.materials"
        @cancel="showUpSession=false"
        @close="reinit"/>
    
    <DiagRemove
        :model="showRemConfirm"
        text="Are you sure you want to delete the file?"
        @cancel="showRemConfirm=false"
        @remove="removeFile"/>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Sessions from '@/firebase/sessions'
import DiagSessions from '@/components/core/dialogs/DiagSessions'

export default {
    data: () => ({
        loaded: true,
        sending: false,
        showUpSession: false,
        showRemConfirm: false,
        model: {
            session: '',
            tips: [''],
            materials: []
        },
        sessions: [
            {title:'Session 1', id:'s1'},
            {title:'Session 2', id:'s2'},
            {title:'Session 3', id:'s3'},
            {title:'Session 4', id:'s4'},
            {title:'Session 5', id:'s5'},
            {title:'Session 6', id:'s6'},
            {title:'Session 7', id:'s7'},
            {title:'Session 8', id:'s8'},
            {title:'Session 9', id:'s9'},
            {title:'Session 10', id:'s10'},
            {title:'Session 11', id:'s11'},
            {title:'Session 12', id:'s12'},
            {title:'Session 13', id:'s13'},
            {title:'Session 14', id:'s14'},
            {title:'Session 15', id:'s15'},
            {title:'Session 16', id:'s16'},
            {title:'Session 17', id:'s17'},
            {title:'Session 18', id:'s18'},
            {title:'Session 19', id:'s19'},
            {title:'Session 20', id:'s20'},
            {title:'Session 21', id:'s21'},
            {title:'Session 22', id:'s22'},
            {title:'Session 23', id:'s23'},
            {title:'Session 24', id:'s24'},
            {title:'Session 25', id:'s25'},
            {title:'Session 26', id:'s26'},
            {title:'Session 27', id:'s27'},
            {title:'Session 28', id:'s28'},
            {title:'Session 29', id:'s29'},
            {title:'Session 30', id:'s30'},
            {title:'Session 31', id:'s31'},
            {title:'Session 32', id:'s32'},
            {title:'Session 33', id:'s33'},
            {title:'Session 34', id:'s34'},
            {title:'Session 35', id:'s35'},
            {title:'Session 36', id:'s36'}
        ]
    }),
    components: {
        DiagSessions
    },
    methods: {
        reinit() {
            this.showUpSession = false;
            this.showRemConfirm = false;
            this.getSession();
        },
        validate() {
            if (this.validateIsEmpty(this.model.session)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a session.'});
                return;
            }

            if (this.model.tips.length == 1 && this.validateIsEmpty(this.model.tips[0])) {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set at least one tip.'});
                return;
            }

            this.save();
        },
        getSession() {
            this.loaded = false;

            this.model.tips = ['']
            this.model.materials = [];

            Sessions.get(this.model.session)
                    .then(response => {
                        if (response.status === true) {
                            this.model.tips = response.doc.data().tips;

                            if (response.doc.data().materials) {
                                this.model.materials = response.doc.data().materials;
                            }

                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        save() {
            this.sending = true;

            let final = {}
            final.tips = this.model.tips;

            Sessions.save(this.model.session, final)
                    .then(response => {
                        if (response === true) {
                            this.reinit();
                            this.$store.dispatch('setSnack', {kind:'success', text:'A new session has added.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        tryConfirm(index) {
            this.showRemConfirm = true;
            this.indexToRemove = index;
        },
        removeFile() {
            let nameToRemove = this.model.materials[this.indexToRemove].name;
            this.model.materials.splice(this.indexToRemove, 1);

            Sessions.removeFile(this.model, nameToRemove)
                    .then(response => {
                        if (response === true) {
                            this.reinit();
                            this.$store.dispatch('setSnack', {kind:'success', text:'The file has been deleted.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });

            this.showRemConfirm = false;
        }
    }
}
</script>